export const getGreetingByTime = (): string => {
    const currentUTC = new Date().getUTCHours();

    if (currentUTC >= 5 && currentUTC < 12) {
        return 'GOOD_MORNING';
    }

    if (currentUTC >= 12 && currentUTC < 18) {
        return 'GOOD_AFTERNOON';
    }

    return 'GOOD_EVENING';
};

export const calculateMinutes = (dataInMillisecondi: number): string => {
    const adessoInMillisecondi = new Date().getTime();
    const differenzaInMillisecondi = adessoInMillisecondi - dataInMillisecondi;

    const giorni = Math.floor(differenzaInMillisecondi / (1000 * 60 * 60 * 24));
    const ore = Math.floor((differenzaInMillisecondi % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minuti = Math.floor((differenzaInMillisecondi % (1000 * 60 * 60)) / (1000 * 60));

    let tempoTrascorsoStringa = '';
    if (giorni > 0) {
        tempoTrascorsoStringa += `${giorni} ${giorni === 1 ? 'giorno' : 'giorni'}`;
        if (ore > 0) {
            tempoTrascorsoStringa += `, ${ore} ${ore === 1 ? 'ora' : 'ore'}`;
        }
    } else if (ore > 0) {
        tempoTrascorsoStringa += `${ore} ${ore === 1 ? 'ora' : 'ore'}`;
        if (minuti > 0) {
            tempoTrascorsoStringa += ` e ${minuti} ${minuti === 1 ? 'minuto' : 'minuti'}`;
        }
    } else {
        tempoTrascorsoStringa = `${minuti} ${minuti === 1 ? 'minuto' : 'minuti'}`;
    }

    return `${tempoTrascorsoStringa} fa`;
};
